<template>
  <q-card
    class="cursor-pointer overflow-hidden"
    :class="{ 'col q-mx-auto': $isLandscapeView() && $q.screen.gt.xs && !compact }"
    :style="{
      'max-width': $isLandscapeView() && $q.screen.gt.xs && !compact ? '350px' : '800px',
      'margin-bottom': $q.screen.gt.xs ? '20px' : undefined
    }"
    v-bind="$attrs"
    @click="navigateToActivityPage()"
  >
    <component
      :is="!$isLandscapeView() || $q.screen.lt.sm || compact? 'q-card-section' : 'div'"
      :horizontal="!$isLandscapeView() || $q.screen.lt.sm || compact"
    >
      <q-img
        :class="{
          'poster': !$isLandscapeView() || $q.screen.lt.sm || compact,
          'col-5': !$isLandscapeView() && $q.screen.xs,
          'col-3': !$isLandscapeView() && $q.screen.gt.xs,
          'rounded-borders-8': rounded
        }"
        :src="useBannerImage ? activity.bannerImageUrl : activity.posterImageUrl"
        :ratio="useBannerImage ? 16/9 : 2/3"
      />
      <q-card-section
        :class="{
          'q-pa-none': $isLandscapeView(),
          'q-pb-sm q-pt-none q-px-none': !$isLandscapeView(),
          'col-auto': !$isLandscapeView(),
          'full-width': compact
        }"
      >
        <div
          class="column"
          :class="$q.screen.gt.xs ? 'q-pa-md' : 'q-pa-sm'"
        >
          <div
            class="activity-name text-bold text-body1"
            style="line-height : 1.5rem"
          >
            {{ activity.name }}
          </div>
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <!-- Set internally by trusted admins -->
        <template v-if="showSessionTimesAndSpace">
          <q-separator v-if="$isLandscapeView() && $q.screen.gt.xs && !compact" />
          <div
            :class="$q.screen.gt.xs ? 'q-pa-md column' : 'row q-gutter-xs q-pl-sm'"
            class="column"
          >
            <div
              v-if="!$_.isNil(activityBooking?.siteEntryTime)"
              :class="$q.screen.gt.xs ? 'text-body1' : 'text-body2 col-auto text-dark'"
            >
              {{ $d(activityBooking.siteEntryTime, 'longDate') }}
            </div>
            <div
              v-if="!$_.isNil(activityBooking?.siteEntryTime)"
              class="text-responsive-grey-7"
              :class="$q.screen.gt.xs ? 'text-body1' : 'text-body2 col'"
            >
              {{ $d(activityBooking.siteEntryTime, 'shortTime') }}
            </div>
            <div
              v-if="!$_.isNil(activityBooking?.activitySpace)"
              class="text-responsive-grey-7"
              :class="$q.screen.gt.xs ? 'text-body1' : 'text-body2 col'"
            >
              {{ activityBooking.activitySpace.name }}
            </div>
          </div>
        </template>
        <current-site-details
          :show-separator="$isLandscapeView() && $q.screen.gt.xs && !compact"
          :class="$q.screen.gt.xs ? 'q-pa-md column' : 'row q-gutter-xs q-pl-sm'"
          :compact="compact"
        />
      </q-card-section>
    </component>
    <slot name="activity-card-actions" />
  </q-card>
</template>

<script>
import Activity from 'src/models/activity/Activity'
import ActivityBooking from 'src/models/activity/ActivityBooking'
import CurrentSiteDetails from 'src/modules/checkout/components/CurrentSiteDetails'

export default {
  name: 'ActivityCard',
  components: {
    CurrentSiteDetails
  },
  inject: ['order'],
  props: {
    activity: {
      type: Activity,
      required: true
    },
    activityBooking: {
      type: ActivityBooking,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    },
    bannerImage: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    spaced: {
      type: Boolean,
      default: false
    }
  },
  configuration: ['currentSite'],
  emits: ['select-activity', 'create-another-booking'],
  computed: {
    useBannerImage () {
      return this.compact || (this.$isLandscapeView() && this.$q.screen.lt.md) || this.bannerImage
    },
    showSessionTimesAndSpace () {
      return !_.isNil(this.activityBooking?.siteEntryTime) ||
      !_.isNil(this.activityBooking?.activitySpace) ||
      !_.isNil(this.activityBooking?.activitySpace)
    }
  },
  methods: {
    navigateToActivityPage () {
      if (this.$register) {
        this.$emit('select-activity', this.activity)
      } else {
        this.$q.dialog({
          title: 'Leave Checkout',
          message: 'Are you sure you want to leave checkout?',
          ok: {
            label: 'Go To Activity',
            color: 'primary'
          },
          cancel: {
            label: 'Stay',
            color: 'secondary'
          }
        }).onOk(() => {
          this.order.reset()
          this.$router.push(`/activity/${this.activity.urlSlug}`)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .poster {
    max-width: 200px;
    min-width: 150px;
  }
  .activity-card {
    width: 100%;
    margin-bottom: 20px;
  }
  .activity-name {
    color: var(--q-primary);
  }
  .rounded-borders-8 {
    border-radius: 8px !important;
  }
</style>
